<template>
    <b-card no-body>
        <b-card-header class="d-flex align-items-center">
            <h3 class="h6 mr-auto mb-0 font-weight-bold" v-html="formattedName" />

            <b-button-group
                v-if="canBeCompleted"
                class="ml-3"
            >
                <b-button
                    v-if="value.api_type === 'wall_foundation'"
                    class="text-nowrap"
                    size="sm"
                    variant="danger"
                    @click="handleDelete"
                >
                    {{ $t('Delete') }}
                    <fa class="ml-1" icon="trash" />
                </b-button>

                <complete-services
                    :api-url="apiUrl"
                    :project-id="+projectId"
                    :service-id="value.id"
                    @services-completed="$emit('completed', $event)"
                >
                    <template #activator="{toggle}">
                        <b-button
                            class="text-nowrap"
                            size="sm"
                            variant="success"
                            @click="toggle"
                        >
                            {{ $t('Mark completed') }}
                            <fa class="ml-1" icon="check" />
                        </b-button>
                    </template>
                </complete-services>
            </b-button-group>
        </b-card-header>

        <b-card-body>
            <template v-if="value.info && value.info.unclear">
                <h4 class="h6">
                    <b>{{ $t('Notice') }}</b>
                </h4>
                <p>{{ value.info.notice }}</p>
            </template>

            <template v-if="value.info && value.info.area">
                <h4 class="h6">
                    <b>{{ $t('Area') }}</b>
                </h4>
                <p>{{ value.info.area }} m<sup>2</sup></p>
            </template>

            <h4 class="h6">
                <b>{{ $t('Completed steps') }}</b> <small>({{ completedStepsCount }} / {{ stepsToComplete }})</small>
            </h4>

            <b-table
                v-if="completedSteps.length"
                :fields="fields"
                :items="completedSteps"
            >
                <template #cell(actions)="{item}">
                    <b-button
                        class="text-nowrap"
                        size="sm"
                        variant="warning"
                        @click="deleteCompletion(item.id)"
                    >
                        {{ $t('Delete') }}
                        <fa class="ml-1" icon="recycle" />
                    </b-button>
                </template>
            </b-table>
        </b-card-body>
    </b-card>
</template>

<script>
    import deleteItem from "@/mixins/deleteItem";
    import CompleteServices from "@/components/projects/CompleteServices";

    export default {
        name: "ServicesToCompleteItem",
        components: {CompleteServices},
        mixins: [deleteItem],
        props: {
            value: {
                type: Object,
                required: true
            },
            apiUrl: {
                type: String,
                required: true
            },
            projectId: {
                type: [Number, String],
                required: true,
            },
        },
        data() {
            return {
                fields: [
                    {
                        key: 'date',
                        label: this.$t('Date'),
                        formatter: value => {
                            return this.$moment(value).format('L');
                        }
                    },
                    {
                        key: 'staff_members',
                        label: this.$t('Staff member'),
                        formatter: value => {
                            return (value || []).map(staff_member => staff_member.name).join(', ');
                        }
                    },
                    {
                        key: 'notice',
                        label: this.$t('Notice')
                    },
                    {
                        key: 'actions',
                        class: 'text-right'
                    }

                ]
            }
        },
        computed: {
            canBeCompleted() {
                return this.stepsToComplete > 0 && this.completedStepsCount < this.stepsToComplete;
            },

            completedSteps() {
                if (this.value.completed_steps) {
                    return this.value.completed_steps;
                }

                if (!this.value.info) return [];

                return this.value.info.completed_steps || [];
            },
            completedStepsCount() {
                return this.completedSteps.length;
            },

            formattedName() {
                let service = this.value.service ? this.value.service : this.value;

                return service.formatted_string;
            },

            stepsToComplete() {
                return this.value.steps || (this.value.service ? this.value.service.steps : 0);
            }
        },
        methods: {
            deleteCompletion(completionId) {
                this.$bvModal.msgBoxConfirm(this.$t('Are you sure to delete this item?'), {
                    title: this.$t('Are you sure?'),
                    okVariant: 'danger',
                    okTitle: this.$t('Yes'),
                    cancelTitle: this.$t('No'),
                    hideHeaderClose: false,
                    centered: true
                }).then(value => {
                    if (!value) {
                        return;
                    }

                    this.axios
                        .delete(`${this.apiUrl}/${completionId}`)
                        .then(() => {
                            const completionIndex = this.completedSteps.findIndex(({id}) => id === completionId)
                            this.completedSteps.splice(completionIndex, 1);
                        })
                        .catch(e => e.response || throw e)
                })
            }
        }
    }
</script>
